import { render, staticRenderFns } from "./tag-edit.vue?vue&type=template&id=6c9c9a04&scoped=true"
import script from "./tag-edit.vue?vue&type=script&lang=ts"
export * from "./tag-edit.vue?vue&type=script&lang=ts"
import style0 from "./tag-edit.vue?vue&type=style&index=0&id=6c9c9a04&prod&lang=scss&scoped=true"
import style1 from "./tag-edit.vue?vue&type=style&index=1&id=6c9c9a04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9c9a04",
  null
  
)

export default component.exports